<template>
    <div class="container" style="float: none;">
        <loader v-if="mediaLoading"/>
        <div v-for="mediaType in docMediaTypes" class="form-group">
            <label class="col-md-2 control-label text-label">{{mediaType.name}}</label>
            <div class="col-md-10">
                <table v-show="mediaList.find(x=> {return x.mediaTypeId === mediaType.mediaTypeId})" class="table">
                    <thead>
                        <tr>
                            <th style="width:10%">Download</th>
                            <th style="width:30%">File Name</th>
                            <th style="width:30%">Comment</th>
                            <th style="width:10%">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="mediaItem in mediaList.filter(m => {return m.mediaTypeId === mediaType.mediaTypeId})">
                            <td>
                                <div style="text-align: center;">
                                    <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" v-on:click="mediaDownloadRow(mediaItem.mediaId, mediaItem.mediaTypeId, mediaType.mediaSubtype, mediaItem.parentId, mediaItem.filename)"></a>
                                </div>
                            </td>
                            <td>{{mediaItem.filename}}</td>
                            <td>{{mediaItem.comment}}</td>
                            <td>
                                <div style="text-align: center;">
                                    <a class="fa fa-ban" style="font-size: 18px;" target="_blank" v-on:click="mediaRemove(mediaItem.mediaId, mediaItem.mediaSubtypeId)"></a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-show="!(mediaList.find(x=> {return x.mediaTypeId === mediaType.mediaTypeId}))">
                    <label>No matching records</label>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2">Add Shape File</label>
            <div class="col-md-10">
                <fieldset>
                    <form v-on:submit.prevent class="form" id="mediaForm" data-vv-scope="mediaFile">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.mediaTypeId') }">
                                    <label>Type</label>
                                    <select name="mediaTypeId" class="form-control" v-model="mediaTypeId" v-validate="'required'" data-vv-validate-on="none">
                                        <option disabled value=''>Select a value</option>
                                        <option v-for="mediaType in docUploadMediaTypes" v-bind:value="mediaType.mediaTypeId">
                                            {{mediaType.name}}
                                        </option>
                                    </select>
                                    <div><span v-show="errors.has('mediaFile.mediaTypeId')" class="has-error">File type is required</span></div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.newFile') }">
                                    <label>File</label><br>
                                    <input name="newFile" ref="newFile" class="file" type="file" v-validate="'required'" data-vv-validate-on="none">
                                    <div><span v-show="errors.has('mediaFile.newFile')" class="has-error">File is required</span></div>
                                </div>
                            </div>
                            <div class="col-md-5">
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.comment') }">
                                    <label>Comment</label>
                                    <input name="comment" type="text" class="form-control" v-model="comment" v-validate="'required'" data-vv-validate-on="none">
                                    <div><span v-show="errors.has('mediaFile.comment')" class="has-error">Comment is required</span></div>
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-primary col-md-1" v-on:click="addFile">Upload</button>
                    </form>
                </fieldset>
            </div>
        </div>
        <div class="form-group">
            <label class="col-md-2">Select File for GIS Append</label>
            <div class="col-md-4">
                <select name="mediaAppend" class="form-control" v-model="qaqcSelection.mediaId">
                    <option :value='null'>None</option>
                    <option v-for="media in mediaList" v-bind:value="media.mediaId" :key="media.mediaId">
                        {{media.filename}}
                    </option>
                </select>
            </div>
        </div>
        <div class="form-group" style="margin-top: 20px;">
            <label class="col-sm-2 control-label text-label">QA/QC Status: </label>
            <div class="col-sm-2 alert text-label" :class="qaqcProgressDto.shapeFileAppend ? 'alert-success' : 'alert-danger'">
                {{qaqcProgressDto.shapeFileAppend ? 'Completed' : 'Not Completed'}}
            </div>
            <div class="col-sm-1"></div>
            <div class="col-sm-2">
                <button class="btn btn-primary" v-on:click="completeSection()">Complete Section</button>
            </div>
        </div>
    </div>
</template>

<script>
import mediaService from '../../services/mediaService'
import loggingService from '../../services/util/loggingService'
import { mapState } from 'vuex'
import loader from '@/components/Loader.vue'

import qaqcService from '@/services/qaqcService'

export default {
    components: {
        loader
    },
    name: 'qaqcShapeFileAppend',
    data: function () {
        return {
            isDebug: false,
            mediaLoading: false,
            crrId: this.$route.params.culturalResourceRecordingId,
            docMediaTypes: [
                {name: 'Shape Files', mediaTypeId: mediaService.mediaType.CulturalResourceShapeFile}
            ],
            mediaList: [],
            comment: '',
            mediaTypeId: mediaService.mediaType.CulturalResourceShapeFile,
            mediaSubtypeId: '',
            filename: ''
        }
    },
    props: {
        formDisabled: { default: false },
        loadOnMount: { default: true },
        qaqcEnabled: { default: false },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null }
    },
    computed: {
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        docUploadMediaTypes: function () {
            return [
                {name: 'Shape Files', mediaTypeId: mediaService.mediaType.CulturalResourceShapeFile}
            ]
        },
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                // if there's no shapeFileAppend qa/qc object, create new instance
                if (!this.qaqcProgressDto.qaqcSelections.shapeFileAppend) {
                    this.qaqcProgressDto.qaqcSelections.shapeFileAppend = qaqcService.qaqcSelections().shapeFileAppend
                }
                return this.qaqcProgressDto.qaqcSelections.shapeFileAppend
            } else {
                return {}
            }
        }
    },
    mounted () {
        if (this.loadOnMount) {
            this.loadData()
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Site Form Documents', message)
        },
        loadMedia (mediaTypeId, mediaSubtypeId, parentId) {
            this.log('looking for parent: ' + parentId)
            return mediaService.list(this.$http, mediaTypeId, mediaSubtypeId, parentId).then(result => {
                this.mediaList = this.mediaList.concat(result.data)
                return result
            })
        },
        loadData () {
            this.mediaLoading = true
            this.mediaList = []
            var promises = []
            this.docMediaTypes.forEach(mediaType => {
                promises.push(this.loadMedia(mediaType.mediaTypeId, null, this.crrId))
            })
            Promise.all(promises).then(result2 => {
                this.log('After load, media list count: ' + this.mediaList.length)
                this.mediaLoading = false
            })
        },
        addFile () {
            this.$validator.validateAll('mediaFile').then(result => {
                if (result) {
                    var file = this.$refs['newFile'].files[0]
                    this.log(`Adding file. Type: ${this.mediaTypeId} Comment: ${this.comment} Name: ${file.name}`)
                    mediaService.putFile(this.$http, this.mediaTypeId, this.mediaSubtypeId, this.crrId, file, this.comment).then(result => {
                        this.clearFileInput()
                        this.loadData()
                        this.errors.clear()
                    })
                } else {
                    this.log('Submit File - Invalid Form')
                }
            })
        },
        clearFileInput () {
            document.forms['mediaForm'].reset()
            this.mediaTypeId = ''
            this.mediaSubtypeId = ''
            this.comment = ''
        },
        mediaDownloadRow (mediaId) {
            var mediaItem = this.mediaList.find(x => { return x.mediaId === mediaId })
            this.log(`mediaDownloadRow - mediaId: ${mediaItem.mediaId} , mediaTypeId: ${mediaItem.mediaTypeId}, parentId: ${mediaItem.parentId}`)
            mediaService.get(this.$http, mediaItem.mediaId, mediaItem.mediaTypeId, mediaItem.mediaSubtypeId, mediaItem.parentId).then(function (response) {
                mediaService.saveFileToDownload(response, mediaItem.filename)
            })
        },
        mediaRemove (mediaId, mediaSubtypeId) {
            if (confirm('Are you sure you want to delete this file?')) {
                mediaService.removeByMediaId(this.$http, mediaId).then(result => {
                    this.loadData()
                })
            }
        },
        completeSection () {
            // check if all selections have been made
            if (!this.qaqcSelection.mediaId && !confirm('No Shape File selected for GIS Append.  Are you sure you want to complete this section?')) {
                return
            }
            this.saveQaqcProgress('shapeFileAppend', true)
        }
    }
}
</script>



// WEBPACK FOOTER //
// QaqcShapeFileAppend.vue?c82d6584